var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePhoneNumberInput',{ref:"phoneInput",attrs:{"default-country-code":_vm.$props.defaultCountry},on:{"update":_vm.updateValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }